import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IProduto } from 'src/app/services/ProdutoService/produto.model';
import { ProdutoService } from 'src/app/services/ProdutoService/produto.service';
import { EstoqueService } from 'src/app/services/EstoqueService/estoque.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = { name: string; value: number };

@Component({
  selector: 'app-cadastro-entrada-estoque',
  templateUrl: './cadastro-entrada-estoque.component.html',
  styleUrls: ['./cadastro-entrada-estoque.component.scss']
})
export class CadastroEntradaEstoqueComponent implements OnInit {
  form: FormGroup;
  isLoading = false;
  produtoOptions: IOptions[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private produtoService: ProdutoService,
    private estoqueService: EstoqueService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.fb.group({
      FK_PROD: [null, Validators.required],
      QT_MOVM: [null, [Validators.required, Validators.min(1)]],
      TX_OBSV: ['']
    });
  }

  ngOnInit(): void {
    this.loadProdutos();
  }

  loadProdutos(): void {
    this.isLoading = true;
    this.produtoService.GetProdutos().subscribe({
      next: (produtos: IProduto[]) => {
        this.produtoOptions = produtos
          .filter(p => p.NU_STTS === 1)
          .map(p => ({ name: p.NM_PROD, value: p.PK_PROD }));
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onSelectChange(event: number, name: string): void {
    this.form.controls[name].setValue(event);
  }

  postarDados(): void {
    if (!this.form.valid) {
      this.swalAlert.showAlert('Atenção!', 'Preencha produto e quantidade.', 'warning');
      return;
    }

    const funcionarioId = Number(localStorage.getItem('id') ?? 0);
    this.isLoading = true;
    this.estoqueService
      .CreateEntrada({
        FK_PROD: Number(this.form.controls['FK_PROD'].value),
        QT_MOVM: Number(this.form.controls['QT_MOVM'].value),
        TX_OBSV: this.form.controls['TX_OBSV'].value || undefined,
        FK_FUNC_OPER: funcionarioId || undefined
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/estoque']);
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }
}
